import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, startDate, endDate }) =>
    present(
      repository
        .saveExportBiRun(planzone, startDate, endDate)
        .then((run) => ({ planzone, run }))
        .catch(() => Promise.reject({ planzone, startDate, endDate })),
    );
}

export type { Interactor };

export { createInteractor };
